<main id="main" class="error-404">
  <header class="ba-content-header ba-with-overlay ba-with-image">
    <div class="ba-header-image"><img class="img404" src="errors/error404.svg" alt=""></div>
    <div class="ba-content-wrap">
      <div class="ba-overlay">
        <h1>{{ "error.http.404.title" | i18next }}</h1>
      </div>
    </div>
  </header>
  <div class="container-fluid ba-copytext">
    <h2>{{ "error.http.404.causes.title" | i18next }}</h2>
    <ul>
      <li>{{ "error.http.404.causes.cause-url-changed" | i18next }}</li>
      <li>{{ "error.http.404.causes.cause-deleted" | i18next }}</li>
    </ul>
    <a href="https://www.arbeitsagentur.de/" class="ba-btn ba-btn-primary">
        {{ "error.http.404.actions.home" | i18next }}
    </a>
  </div>
</main>